import { useContext } from 'react'
import { Button } from 'antd'
import i18next from 'i18next'

import { formatDate } from '../utils/utils'
import { getCustomerTags } from '../network/CustomerTags'
import { AppContext } from '../context/AppContext'

import PageWrap from '../components/layout/PageWrap'
import TableBlock from '../components/tables/TableBlock'
import DynamicStrings from '../components/DynamicStrings'

const CustomerTags = ({ history }) => {
    return (
        <PageWrap title="MENU_CUSTOMER_TAGS">
            <TableBlock
                columns={columns}
                filters={filters}
                name={'getCustomerTags'}
                request={getCustomerTags}
                pageSize={80}
                onRow={(record) => {
                    return {
                        onClick: () => {
                            history.push(`/customer-tags/${record.id}`)
                        },
                    }
                }}
            />
        </PageWrap>
    )
}

const filters = (history) => ({
    fields: [
        {
            type: 'text',
            label: 'CUSTOMER_TAGS_TAG_NAME',
            key: 'name',
        },
    ],
    actions: [
        {
            label: 'CUSTOMER_TAGS_CREATE',
            component: () => <BtnCreate history={history} />,
        },
    ],
})

const BtnCreate = ({ history }) => {
    const { user } = useContext(AppContext)

    if (user.role !== 'super-admin' && user.role !== 'admin') {
        return null
    }

    return (
        <Button
            type="primary"
            onClick={() => history.push('/customer-tags/create')}
        >
            <DynamicStrings id={'CUSTOMER_TAGS_CREATE'} />
        </Button>
    )
}

const getTagName = (name) =>
    typeof name === 'string'
        ? name
        : name?.[i18next.language] || name?.en || name?.zh || ''

const columns = () => [
    {
        title: <DynamicStrings id="CUSTOMER_TAGS_TAG_NAME" />,
        dataIndex: 'name',
        key: 'name',
        render: (name) => getTagName(name),
        sorter: true,
    },
    {
        title: <DynamicStrings id="DELIVERY_TEMPLATES_CREATED_DATE" />,
        dataIndex: 'createdAt',
        key: 'createdAt',
        render: (date) => (date ? formatDate(date) : null),
        sorter: true,
    },
]

export default CustomerTags
